import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String
  }

  connect() {
    // Marcar si el navegador soporta la API de compartir
    if ('share' in navigator) {
      this.element.classList.add('has-native-share')
    } else {
      this.element.classList.add('no-native-share')
    }
  }

  async share(event) {
    event.preventDefault()
    try {
      await navigator.share({
        title: this.titleValue,
        text: this.textValue,
        url: this.urlValue
      })
    } catch (err) {
      if (err.name !== 'AbortError') console.error('Error sharing:', err)
    }
  }
}
